import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const BatteryEmptyIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 16 13"
         fill="none"
         {...props}
      >
         <path
            d="M2.22 9.32449C1.73 9.32449 1.33002 8.9345 1.33002 8.4545V4.1245C1.33002 3.9545 1.39 3.81449 1.47 3.68449L0.429993 2.85449C0.159993 3.21449 0 3.6545 0 4.1245V8.4545C0 9.6545 0.990001 10.6245 2.22 10.6245H10.2L8.57001 9.32449H2.22Z"
            fill="currentColor"
         />
         <path
            d="M15.11 4.5546V4.12461C15.11 2.92461 14.12 1.95461 12.89 1.95461H3.61996L1.34997 0.144597C1.05997 -0.0854029 0.639972 -0.0354023 0.409972 0.254598C0.179972 0.544598 0.229988 0.9646 0.519988 1.1946L1.59997 2.0546H1.57999L3.08996 3.2546H3.11996L10.75 9.3246H10.72L12.35 10.6246H12.38L14.65 12.4346C14.77 12.5346 14.92 12.5746 15.06 12.5746C15.26 12.5746 15.45 12.4846 15.58 12.3246C15.81 12.0346 15.76 11.6146 15.47 11.3846L14.08 10.2746C14.7 9.8846 15.11 9.22461 15.11 8.45461V8.0246C15.6 8.0246 16 7.63461 16 7.15461V5.4246C16 4.9446 15.6 4.5546 15.11 4.5546ZM5.24997 3.2546H12.88C13.37 3.2546 13.77 3.64461 13.77 4.12461V8.45461C13.77 8.93461 13.37 9.3246 12.88 9.3246L5.24997 3.2546Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default BatteryEmptyIcon
